import org from './org'
import currentOrg from './currentOrg'
import device from './device'
import departmentManage from './departmentManage'
import role from './role'
import place from './place'
import user from './user'

export default {
  org,
  currentOrg,
  device,
  departmentManage,
  role,
  place,
  user
}
